// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"a494837a","97":"a733e65a","260":"ba4ba3f6","293":"9be545bf","374":"82058ee9","450":"a567ae5b","453":"02b75004","501":"19ad4051","818":"a838b9e1","917":"9237e39d"}[chunkId] + ".chunk.js";
};